export default __webpack_public_path__ + "static/media/Short Straddle.46e3f79e.svg";